import React from 'react';
import '../styles/About.css';

function About() {
    return (
        <section className="about" id="about">
            <h2>Hakkımızda</h2>
            <p>Antalya'nın her noktasında 7/24 oto çekici-kurtarıcı ve yol yardım hizmeti sunuyoruz.
                Araç arızası veya kaza durumlarında modern ekipmanlarımızla, hızlı ve güvenilir çözümler üretiyoruz.
                Yolda kalmamanız için buradayız.
            </p>
            <div className="gallery">
                <img src="/assets/foto.jpeg" alt="foto"/>
            </div>
        </section>
    );
}

export default About;
